/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Philosophy17Inputs */

const en__field_enum_subject_philosophy17 = /** @type {(inputs: _Field_Enum_Subject_Philosophy17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophy`)
};

const de__field_enum_subject_philosophy17 = /** @type {(inputs: _Field_Enum_Subject_Philosophy17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophie`)
};

/**
* | output |
* | --- |
* | "Philosophy" |
*
* @param {_Field_Enum_Subject_Philosophy17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_philosophy17 = /** @type {((inputs?: _Field_Enum_Subject_Philosophy17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Philosophy17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_philosophy17(inputs)
	return de__field_enum_subject_philosophy17(inputs)
});
export { _field_enum_subject_philosophy17 as "_field_enum_SUBJECT_PHILOSOPHY" }